import React from 'react';
import {
  FlexCol,
  FlexRow,
  BodyTextLarge,
  TextDynamic,
  H1Text,
  BasicContainer,
  H3Text,
  BodyTextSmall,
  PaywallButton,
} from '@minecraft.atoms';
import IconWithErrorBoundary from '@minecraft.icon';
import { Trans, useTranslation } from '../../../../I18N';
import { DiscountModalProps } from '../useDiscountHook';

export const NeverPaidCohortDiscount = ({
  billedText,
  discountedPlan,
  onCTAClick,
  originalPrice,
  price,
}: DiscountModalProps) => {
  const { t } = useTranslation();
  const planFeatures = [
    t('common:paywall.features.premium.storageUnlimited'),
    t('common:paywall.features.premium.trackSubmissions'),
    t('common:paywall.features.premium.plan.thriveBenefits'),
  ];

  return (
    <FlexCol justifyItems="center" alignItems="center" gap="6" w="full" mt="8" mb="4">
      <IconWithErrorBoundary name="never-paid-asset" />
      <TextDynamic align="center" fontSize="xl" fontWeight="semibold">
        {t('common:paywall.plan.never_paid_discount_offer')}
      </TextDynamic>
      <FlexRow
        bgColor="discountOfferBg"
        borderRadius="md"
        className="cn_atom_p-2"
        gap="1"
        alignItems="center"
        justifyItems="center"
      >
        <H1Text color="discountHighlight">
          <IconWithErrorBoundary name="discount-tag" inheritColor className="cn_mx-2" />
          {t('common:paywall.plan.save_offer', { discountPercent: discountedPlan?.discountPercent })}
        </H1Text>
      </FlexRow>
      <BasicContainer>
        <BodyTextLarge color="disabled" align="center">
          {t('common:paywall.plan.never_paid_discount_offer_subtext1')}
        </BodyTextLarge>
        <BodyTextLarge color="disabled" align="center">
          {t('common:paywall.plan.never_paid_discount_offer_subtext2')}
        </BodyTextLarge>
      </BasicContainer>
      <FlexCol w="full" justifyItems="center" alignItems="center" gap="2">
        <BodyTextLarge fontWeight="medium" as="span" textWrap="balance" align="center">
          <Trans
            i18nKey="common:paywall.plan.upgrade_premium_discount"
            components={[
              <BodyTextLarge fontWeight="medium" color="disabled" className="cn_line-through" as="span" />,
              <H3Text fontWeight="bold" color="discountHighlight" as="span" />,
            ]}
            values={{
              originalPrice,
              price,
            }}
          />
        </BodyTextLarge>
        {billedText && <BodyTextSmall color="disabled">{billedText}</BodyTextSmall>}
      </FlexCol>
      <FlexCol w="full" gap="4" mdProps={{ w: '2/3' }}>
        {planFeatures?.map((feature) => (
          <FlexRow gap="3" alignItems="start" w="full" key={feature}>
            <IconWithErrorBoundary name="check-circle" themeColor="discountOffer" />
            <BasicContainer w="4/5">
              <BodyTextSmall textWrap="balance">
                <Trans i18nKey={feature} components={[<b />]} />
              </BodyTextSmall>
            </BasicContainer>
          </FlexRow>
        ))}
        <PaywallButton
          label={t('common:paywall.plan.discount.claim_offer')}
          color="discount"
          onClick={onCTAClick}
          full
          isSmall
        />
      </FlexCol>
    </FlexCol>
  );
};
